import type { SxProps } from '@mui/material';
import { Box } from '@mui/material';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  slotProps?: {
    wrapper?: {
      sx?: SxProps;
    };
    container?: {
      sx?: SxProps;
    };
  };
}

export function Scroll({ slotProps, children }: Props) {
  return (
    <Box sx={{ flexGrow: 1, position: 'relative', ...slotProps?.wrapper?.sx }}>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          overflow: 'auto',
          ...slotProps?.container?.sx,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
